export default __webpack_public_path__ + "static/media/LENS_CULINARIS_OGRE_complete_1.35764488.jpg";